import React, { useContext, useEffect, useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { LOCAL_STORAGE_PREFIX, FIAT_CURRENCIES } from 'const';
import { CurrencyContext } from 'context';
import { useFiatRates, useGameDetails } from 'utils/Hooks';
import IconBNB from 'assets/icons/BNBblack.svg';
import IconMATIC from 'assets/icons/MATIC.svg';
import IconBTC from 'assets/icons/BTC.svg';
import IconWDOGE from 'assets/icons/wDOGE.svg';
import IconDOGE from 'assets/icons/DOGE.svg';
import './index.css';


export function NetworkCurrencySymbol(props) {
  const { currencyID, SetCurrencyID } = useContext(CurrencyContext);
  const gameDetails = useGameDetails();
  let output = null;

  function HandleClick() {
    if (currencyID !== 0) {
      SetCurrencyID(0);
      localStorage.setItem(LOCAL_STORAGE_PREFIX + 'currency', 0);
    }
  };

  switch (gameDetails.wantedChain.tickerSymbol) {
    case 'BNB':
      output = (<img src={IconBNB} alt='BNB' />);
      break;
    case 'MATIC':
      output = (<img src={IconMATIC} alt='MATIC' />);
      break;
    case 'wDOGE':
      output = (<img src={IconWDOGE} alt='wDOGE' />);
      break;
    default:
      output = (<img src='' alt='UnknownImg' />);
      break;
  }
  return (<div
    className={`NetworkCurrencySymbol ${currencyID == 0 || props.active ? "active" : "inactive"}`}
    onClick={HandleClick}
  >
    {output}
  </div>);
}


export function FiatCurrencySymbol(props) {
  if (props.cryptoAmount === undefined)
    throw new SyntaxError('Missing required prop: cryptoAmount');

  const { currencyID, SetCurrencyID } = useContext(CurrencyContext);
  const [price, SetPrice] = useState(0);
  const fiatRates = useFiatRates();

  const figureMain = useMemo(FigureMain
    , [currencyID, price, props.cryptoAmount]);
  const figureTooltip = useMemo(FigureTooltip
    , [currencyID, price, props.cryptoAmount]);

  useEffect(() => {
    const wantedFiatTicker = FIAT_CURRENCIES[GetCurrencyID_safe()]?.symbol;
    SetPrice(fiatRates[wantedFiatTicker]);
  }, [currencyID, fiatRates]);

  function GetCurrencyID_safe() {
    return (currencyID || 1);
  }

  function HandleClick() {
    let nextCurrencyID = currencyID + 1;
    if (nextCurrencyID >= FIAT_CURRENCIES.length) {
      nextCurrencyID = 1;
    }
    SetCurrencyID(nextCurrencyID);
    localStorage.setItem(LOCAL_STORAGE_PREFIX + 'currency', nextCurrencyID)
  }

  function FigureMain() {
    if (currencyID != 0 && props.cryptoAmount)
      return (<div className='Figure'>
        {(price * props.cryptoAmount).toFixed(2)}
      </div>);
    else
      return null;
  }

  function FigureTooltip() {
    if (currencyID == 0 && props.cryptoAmount)
      return (<div className='Tooltip'>
        {(price * props.cryptoAmount).toFixed(2)}
      </div>);
    else
      return null;
  }

  function IsActive() {
    if (currencyID == 0)
      return ' inactive';
    else
      return ' active';
  }

  if (props.interactive)
    return (
      <div className={'FiatCurrencySymbol' + IsActive()} onClick={HandleClick}>
        <div>{
          FIAT_CURRENCIES[GetCurrencyID_safe()] &&
          <FontAwesomeIcon icon={FIAT_CURRENCIES[GetCurrencyID_safe()]?.icon} />
        }</div>
        <div></div>
      </div>
    );
  else if (isNaN(props.cryptoAmount))
    return (props.cryptoAmount);
  else
    return (<React.Fragment>
      {figureMain}
      <div className={'FiatCurrencySymbol' + IsActive()} onClick={HandleClick}>
        <div>
          {FIAT_CURRENCIES[currencyID] &&
            <FontAwesomeIcon icon={FIAT_CURRENCIES[GetCurrencyID_safe()]?.icon} />}
        </div>
        {figureTooltip}
      </div>
    </React.Fragment>);
}




export function PredictionCurrencySymbol(props) {
  const gameDetails = useGameDetails();
  switch (gameDetails.tickerSymbol) {
    case 'BNB':
      return <img className='PredictionCurrencySymbol' src={IconBNB} alt='BNBimg' />
    case 'BTC':
      return <img className='PredictionCurrencySymbol' src={IconBTC} alt='BTCimg' />
    case 'MATIC':
      return <img className='PredictionCurrencySymbol' src={IconMATIC} alt='MATICimg' />
    case 'DOGE':
      return <img className='PredictionCurrencySymbol' src={IconDOGE} alt='DOGEimg' />
    default:
      return <img className='PredictionCurrencySymbol' src='' alt='UnknownImg' />
  }
}
